import React from 'react';

/* eslint-disable react/prop-types */

export default function ({ color }) {
  // viewBox 0 0 24 24
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M10.5 13.5c.3.3.3.8 0 1.1l-2.9 3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2l-1.1-1.2c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l.6.6 2.3-2.4c.2-.3.7-.3 1 0zm0-7c.3.3.3.8 0 1.1l-2.9 3c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L5.5 9.3c-.3-.3-.3-.8 0-1 .3-.3.8-.3 1 0l.6.6 2.3-2.4c.3-.3.8-.3 1.1 0zM12.2 9c0-.4.3-.8.8-.8h5c.4 0 .8.3.8.8s-.4.8-.8.8h-5c-.4 0-.8-.4-.8-.8zm0 7c0-.4.3-.8.8-.8h5c.4 0 .8.3.8.8s-.3.8-.8.8h-5c-.4 0-.8-.4-.8-.8z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M22.6 6.4c-.2-1.4-.6-2.6-1.5-3.5-.9-.9-2-1.3-3.5-1.5-1.4-.2-3.3-.2-5.6-.2s-4.2 0-5.6.2C5 1.6 3.9 2 3 2.9c-.9.9-1.3 2.1-1.5 3.5-.2 1.4-.2 3.2-.2 5.5v.1c0 2.3 0 4.1.2 5.5.2 1.5.6 2.7 1.5 3.6.9.9 2 1.3 3.5 1.5 1.4.2 3.3.2 5.6.2s4.2 0 5.6-.2c1.4-.2 2.6-.6 3.5-1.5.9-.9 1.3-2 1.5-3.5.2-1.4.2-3.2.2-5.5V12c-.2-2.4-.2-4.2-.3-5.6zm-1.5 11c-.2 1.3-.5 2-1.1 2.6s-1.3.9-2.6 1.1c-1.3.2-3 .2-5.4.2s-4.1 0-5.4-.2c-1.3-.2-2-.5-2.6-1.1-.6-.6-.9-1.3-1.1-2.6-.2-1.3-.2-3-.2-5.4 0-2.4 0-4.1.2-5.4.2-1.3.6-2 1.1-2.6.6-.6 1.3-.9 2.6-1.1 1.3-.2 3-.2 5.4-.2s4.1 0 5.4.2c1.3.2 2 .5 2.6 1.1.6.6.9 1.3 1.1 2.6.2 1.3.2 3 .2 5.4-.1 2.4-.1 4.1-.2 5.4z"
      />
    </>
  );
}
